<template>
  <div class="newindex">
    <div class="header">
      <!-- <span class="btn_study" @click="showJiaochengDialog">教程</span> -->
      <span class="btn_study" @click="Toast1('开发中')">教程</span>
      <router-link :to="{ path: '/jiaodian/search' }" class="item">
        <div class="btn_searchpage"><label>搜索</label></div>
      </router-link>
      <router-link :to="{ path: '/jiaodian/brand' }" class="item">
        <div class="btn_changepage">修改品牌</div>
      </router-link>
    </div>
    <div class="menu">
      <router-link to="/clock" tag="div" class="nav_a">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico1.png"
        />
        <span>早晚安打卡</span>
      </router-link>
      <router-link
        to="/square"
        tag="div"
        class="nav_a"
        @click="Toast1('开发中')"
      >
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico2.png"
        />
        <span>人脉广场</span>
      </router-link>
      <wx-open-launch-weapp
        username="gh_71dc8139aba8"
        path="pages/index/index.html"
        class="nav_a"
        @error="handleErrorFn"
        @launch="handleLaunchFn"
      >
        <script type="text/wxtag-template">
          <style>
            .img{
              display: block;
              width: 60%;
              margin: 0 auto 6px;
            }
            .name{
              display: block;
              width: 100%;
              text-align: center;
              font-size: 12px;
              color: #333;
            }
          </style>
            <div>
              <img
                class="img"
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico5.png"
              />
              <span class="name">获客商城</span>
            </div>
        </script>
      </wx-open-launch-weapp>
      <!-- <wx-open-launch-weapp class="nav_a" @click="gopage">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico5.png"
        />
        <span>获客商城</span>
      </wx-open-launch-weapp> -->
      <div class="nav_a" @click="gopage">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico6.png"
        />
        <span>魔镜</span>
      </div>
      <!--  <div class="nav_a" @click="Toast1('开发中')">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico3.png"
        />
        <span>引流好课</span>
      </div>
      <div class="nav_a" @click="Toast1('开发中')">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/indexico4.png"
        />
        <span>热门好书</span>
      </div> -->
    </div>
    <div class="menu2">
      <div
        :class="cid == 0 ? 'menu2_1 activeNav' : 'menu2_1'"
        @click="clickNavA(0)"
      >
        首页
      </div>
      <div class="menu2_2">
        <div>
          <span
            @click="clickNavA('video')"
            :class="cid == 'video' ? 'activeNav' : ''"
            >视频</span
          >
          <span
            v-if="brandList.length > 1"
            :class="cid == 'brand' ? 'activeNav' : ''"
            @click="clickNavA('brand')"
            >我的品牌</span
          >
          <span
            v-if="brandList.length == 1"
            v-for="(item, index) in brandList"
            :key="index"
            :class="cid == 'brand' ? 'activeNav' : ''"
            @click="clickNavA('brand')"
            >{{ item.title }}</span
          >
          <span
            v-for="(item, index) in navLst"
            :key="index"
            @click="clickNavA(item.pid)"
            :class="cid == item.pid ? 'activeNav' : ''"
            data-id="item.id"
            >{{ item.cat_title }}</span
          >
        </div>
      </div>
      <div class="menu2_3">
        <router-link :to="{ path: '/jiaodian/brand' }" class="item">
          <img
            src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/addico.png"
          />
        </router-link>
      </div>
    </div>
    <div class="menu3" v-if="brandList.length > 1 && cid == 'brand'">
      <div class="menu3_1">
        <div>
          <span @click="clickNavB(0)" :class="bid == 0 ? 'activeNav2' : ''"
            >全部</span
          >
          <span
            v-for="(item, index) in brandList"
            :class="bid == item.pid ? 'activeNav2' : ''"
            @click="clickNavB(item.pid)"
            >{{ item.title }}</span
          >
        </div>
      </div>
      <div class="editBtn">
        <router-link :to="{ path: '/jiaodian/brand/addBrand' }" class="item"
          >编辑
        </router-link>
      </div>
    </div>
    <div class="content_list">
      <!-- 文本列表 -->
      <div class="content_1" v-if="textContent">
        <newlist :cid-list="cidList"></newlist>
        <div
          v-if="hasTextList"
          style="font-size: .24rem;color: #999999;text-align: center;padding: .2rem 0;"
        >
          <div class="yindao" v-if="yindaoImg">
            <img
              src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_yindao1.png"
              width="100%"
            />
          </div>
          {{ adddataText }}
        </div>
      </div>
      <!-- 视频列表 -->
      <div class="content_1" v-if="videoContent">
        <ul class="videoUl">
          <li v-for="(item, index) in videolist" :key="index">
            <router-link :to="{ path: '/video/index?id=' + item.id }">
              <div class="videoImg">
                <img :src="item.video_cover" />
              </div>
              <div class="videoText">
                <div class="videoTitle">
                  {{ item.video_name }}
                </div>
                <div class="video_tag">
                  <span>#{{ item.cat_title }}</span>
                  <span>引流{{ item.visit }}次</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <div
          v-if="hasvideoList"
          style="font-size: .24rem;color: #999999;text-align: center;padding: .2rem 0;"
        >
          {{ adddataText }}
        </div>
      </div>
    </div>
    <!-- 教程弹窗 -->
    <div class="jiaocheng dialog" v-if="jiaochengDialog">
      <div class="jiaocheng_content">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_close.png"
          class="yz_close"
          @click="hideJiaochengDialog"
        />
        <div class="jc_title">常见问题</div>
        <div class="jc_li">1.这是什么平台，有什么用？</div>
        <div class="jc_li">1.这是什么平台，有什么用？</div>
      </div>
    </div>
    <div style="height: 1.5rem;"></div>
    <span class="addText"
      ><img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_icoedit.png"
      /><router-link :to="{ path: '/jiaodian/addarticle' }"
        >添加文章</router-link
      ></span
    >
  </div>
</template>

<script>
import "@assets/css/newhomeindex.css";
import "@assets/css/newlist.css";
import { Toast, Dialog } from "vant";
// import GoodList from "@components/GoodList";
// import PromotionGood from "@components/PromotionGood";
// import CouponWindow from "@components/CouponWindow";
import newlist from "@components/newlist";
import {
  getHomeData,
  getShare,
  follow,
  getFollowLstNew,
  getBrandLst,
  getArticleListNew,
  getBrandListNew,
  getVideoListNew,
} from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
import wx from "weixin-js-sdk";
import { getWechatConfig } from "@api/public";
let vm = null;
export default {
  name: "Index",
  components: {
    newlist,
    [Dialog.name]: Dialog,
    // GoodList,
    // PromotionGood,
    // CouponWindow
  },
  props: {},
  data: function() {
    return {
      yindaoImg: false,
      hasTextList: false,
      hasvideoList: false,
      adddataText: "...",
      activeName: "1",
      jiaochengDialog: false,
      textContent: true,
      videoContent: false,
      navLst: [],
      brandList: [], //子分类
      cid: 0, // 存储对应的行业id,默认首页为0
      bid: 0, //默认为0，显示我的品牌下的所有
      page: 1,
      // checkedCid: 0, //选中的cid,默认首页为0
      cidList: [], //行业cid对应的列表
      videolist: [], //视频列表
      finished: true,
      urlIndex: 0,
      isadd: true, //是否还需要加载
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      mapKey: "",
    };
  },
  created() {
    vm = this;
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log("val:", val);
        console.log("oldVal:", oldVal);
        this.finished = true;
        this.page = 1;
        if (val.fullPath == "/?index=1") {
          //激活了底部视频
          this.urlIndex = 1;
          this.videolist = [];
        } else {
          //激活首页
          this.urlIndex = 0;
          this.cidList = [];
          this.textContent = true;
          this.videoContent = false;
        }
        this.getFollowLstNew();
        this.getFollow();
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted: function() {
    getWechatConfig().then((data) => {
      console.log(data.data);
      wx.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "translateVoice",
          "startRecord",
          "stopRecord",
          "onRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      wx.ready(function() {
        //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
    this.urlIndex = this.$route.query.index;
    this.getFollowLstNew();
    this.getFollow();
    let that = this;
    window.addEventListener("scroll", that.scrollBottom);
  },
  methods: {
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn(e) {
      console.log("success");
    },
    Toast1(txt) {
      Toast(txt);
    },
    getFollowLstNew() {
      getFollowLstNew().then((res) => {
        if (res.data.cate.length == 0 && res.data.brand.length == 0) {
          Dialog.alert({
            message: "您还没有关注的行业和品牌！请务必先去关注一波~",
            theme: "round-button",
          }).then(() => {
            // on close
            window.location.href = "/jiaodian/brand";
          });
        }
        this.navLst = res.data.cate;
        this.brandList = res.data.brand;
        this.yindaoImg = false;
        if (this.urlIndex == 1) {
          //表示需要初始渲染视频模块
          this.textContent = false;
          this.videoContent = true;
          this.cid = "video"; //初始默认cid为0,显示首页全部行业的数据
          this.hasTextList = false;
          this.adddataText = "";
          this.hasvideoList = false;
          this.getVideoListNew();
        } else {
          this.cid = 0; //初始默认cid为0,显示首页全部行业的数据
          this.hasTextList = false;
          this.adddataText = "";
          this.getArticleList();
        }
      });
    },
    getVideoListNew() {
      if (this.finished) {
        this.finished = false;
        var data = "?page=" + this.page + "&limit=12";
        getVideoListNew(data)
          .then((res) => {
            console.log("初始获取视频");
            if (res.data.length <= 0) {
              this.finished = false;
              this.adddataText = "我是有底线的~";
              this.hasvideoList = true;
            } else {
              this.videolist = this.videolist.concat(res.data);
              if (res.data.length < 12) {
                this.finished = false;
                this.adddataText = "我是有底线的~";
                this.hasvideoList = true;
              } else {
                this.finished = true;
                this.adddataText = "数据加载中...";
                this.hasvideoList = true;
              }
            }
          })
          .catch((err) => {
            this.finished = false;
          });
      }
    },
    // 行业列表
    getArticleList() {
      if (this.finished) {
        this.finished = false;
        var data = this.cid + "?page=" + this.page + "&limit=10";
        getArticleListNew(data)
          .then((res) => {
            console.log("获取相应列表1：", res);
            if (res.data.length <= 0) {
              this.finished = false;
              this.hasTextList = true;
              this.adddataText = "我是有底线的~";
            } else {
              this.cidList = this.cidList.concat(res.data);
              if (res.data.length < 10) {
                this.finished = false;
                this.hasTextList = true;
                this.adddataText = "我是有底线的~";
              } else {
                this.hasTextList = true;
                this.adddataText = "数据加载中...";
                this.finished = true;
              }
            }
          })
          .catch((err) => {
            this.finished = false;
          });
      }
    },
    clickNavA(e) {
      console.log(e);
      this.cid = e;
      this.page = 1;
      this.finished = true;
      this.cidList = [];
      this.videolist = [];
      this.yindaoImg = false;
      if (e == "brand") {
        //表示用户点击的是’我的品牌‘,此时bid默认为0，显示品牌列表
        this.bid = 0;
        this.textContent = true;
        this.videoContent = false;
        this.getBrandListNew();
      } else if (e == "video") {
        //点击的视频
        window.location.href = "/?index=1";
        this.textContent = false;
        this.videoContent = true;
        this.getVideoListNew();
      } else {
        this.textContent = true;
        this.videoContent = false;
        this.getArticleList();
      }
    },
    // 品牌列表
    getBrandListNew() {
      if (this.finished) {
        this.finished = false;
        var data = this.bid + "?page=" + this.page + "&limit=10";
        getBrandListNew(data)
          .then((res) => {
            console.log("获取相应品牌文章列表：", res);
            if (res.data.length <= 0) {
              this.finished = false;
              this.adddataText = "我是有底线的~";
              this.hasTextList = true;
              if (this.page == 1) {
                this.yindaoImg = true;
                this.adddataText = "";
              }
            } else {
              this.cidList = this.cidList.concat(res.data);
              if (res.data.length < 10) {
                this.finished = false;
                this.adddataText = "我是有底线的~";
                this.hasTextList = true;
              } else {
                this.finished = true;
                this.hasTextList = true;
                this.adddataText = "数据加载中...";
              }
            }
          })
          .catch((err) => {
            this.finished = false;
          });
      }
    },
    clickNavB(e) {
      console.log(e);
      this.bid = e;
      this.page = 1;
      this.cidList = [];
      this.finished = true;
      this.yindaoImg = false;
      this.getBrandListNew();
    },
    // 显示教程
    showJiaochengDialog() {
      this.jiaochengDialog = true;
    },
    hideJiaochengDialog() {
      this.jiaochengDialog = false;
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    scrollBottom() {
      // console.log("桂东");
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 80;
      // console.log(scrollHeight);
      if (scrollTop != 0 && bottomOfWindow && this.finished == true) {
        this.page = this.page + 1;
        if (this.cid == "video") {
          this.getVideoListNew();
        } else if (this.cid == "brand") {
          this.getBrandListNew();
        } else {
          this.getArticleList();
        }
      }
    },
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({
          path: "/detail/" + item.id,
        });
      });
    },
    gopage() {
      window.location.href = "http://weixin.wedei.com/zt/mojing/index.aspx";
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then((res) => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
body,
html {
  background: #fff !important;
}
.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}
.yindao {
  width: 100%;
  margin: 0.4rem auto 0;
}
</style>
